import _ from 'lodash';

import tpl from './general-info.tpl.html';
import './general-info.scss';


/**
 * A small info component that displays a an icon or an image and title + subtitle.
 */
class InfoComponent {
  constructor() {
    'ngInject';

    /**
     * Title for the card
     * @type {String}
     */
    this.title = null;

    /**
     * Optional subtitle for the card
     * @type {?String}
     */
    this.title = null;

    /**
     * Optional icon class for the card
     * @type {?String}
     */
    this.icon = null;

    /**
     * Optional image url for the card
     * @type {?String}
     */
    this.image = null;

    /**
     * Is this card displayed on very light surface like white so that icon backgrounds need to darken.
     * @type {boolean}
     */
    this.light = false;

    this.onInfoClicked = null;

    this.showExtraInfoLink = false;
  }

  $onInit() {
    this.showExtraInfoLink = _.isFunction(this.onInfoClicked);
  }

  _onInfoClicked() {
    if (this.showExtraInfoLink) {
      this.onInfoClicked();
    }
  }
}

const config = {
  templateUrl: tpl,
  controller: InfoComponent,
  bindings: {
    title: '@',
    subtitle: '@?',
    icon: '@?',
    image: '@?',
    light: '<?',
    onInfoClicked: '&?',
  }
};

const mod = angular.module('app.common.components.info.generalInfo', [])

.component('generalInfo', config);

export default mod.name;
